import React, { useContext } from 'react';
import { BaseContext } from '../../contexts';
import Landing from '../bauCommon/pages/landing';
import Plans from './pages/plans';

const Bau = () => {
  const { page, setPage, onBack, onSelectPlan } = useContext(BaseContext);

  const handleOnGetStarted = () => {
    setPage("plans");
  };

  return (
    <div className="layout">
      <div className="container">
        <div className="content">
          { page === "landing" && <Landing onGetStarted={ handleOnGetStarted } /> }
          { page === "plans" && <Plans onBack={ onBack } onSelect={ onSelectPlan } /> }
        </div>
      </div>
    </div>
  );
};

export default Bau;
